import { screenshotsAccordion } from '../utils/screenshots';
import 'jquery';
import '../utils/slick.js';

document.addEventListener('DOMContentLoaded', function (e) {
  //New agencies competitors pricing accordion
  let competitorsRows = document.querySelectorAll('.competitor-row');
  if (competitorsRows.length > 0) {
    competitorsRows.forEach((item) => {
      item.addEventListener('mouseenter', (event) => {
        item.classList.toggle('open-pricing');
      });
      item.addEventListener('mouseleave', (event) => {
        item.classList.toggle('open-pricing', false);
      });
    });
  }

  screenshotsAccordion();
});

var jq2 = jQuery.noConflict();
jq2(function ($) {
  $(window).on('load resize orientationchange', function () {
    /* discover card-list */
    var cards_slider = $('#discover .card-list');
    if ($(window).width() > 768) {
      if (cards_slider.hasClass('slick-initialized')) {
        cards_slider.slick('unslick');
      }
    } else {
      if (!cards_slider.hasClass('slick-initialized')) {
        cards_slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          infinite: true,
          autoplay: true,
          adaptiveHeight: true,
          dots: true,
          nextArrow: '<div class="slick-arrow slick-arrow-right"></div>',
          prevArrow: '<div class="slick-arrow slick-arrow-left"></div>'
        });
        var card = jQuery('#discover .card-list article');
        card.removeAttr('data-sal data-sal-duration data-sal-delay');
      }
    }
  });

  /* home-logos logo-list */
  var logos_slider = $('#home-logos .logo-list');
  logos_slider.slick({
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    dots: false,
    arrows: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: false
        }
      }
    ]
  });
});
